module.exports = __webpack_public_path__ + "static/media/question-bank-icon.e3743758.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/sidebar/question-bank-icon.svg
// module id = 1032
// module chunks = 0